import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, FileText, Lock, Award } from 'lucide-react';
import { AppContext } from '../AppContext';
import './TermsPage.css';

const iconMap = [Award, ShieldCheck, FileText, Lock];

const TermsPage = () => {
  const { termsEntries, lang } = useContext(AppContext);
  const isMr = lang === 'mr';

  return (
    <div className="terms-page">
      <section className="terms-hero">
        <div className="terms-hero-bg">
          <img src="images/banner a.png" alt="GDR Terms & Conditions" />
          <div className="terms-hero-overlay"></div>
        </div>
        <motion.div
          className="terms-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="terms-eyebrow">✦ GDR POLICIES &amp; COMPLIANCE ✦</span>
          <h1>Terms &amp; Conditions</h1>
          <p>Transparency, purity standards, and customer rights governing our fine jewellery showroom.</p>
        </motion.div>
      </section>

      <div className="terms-container">
        <div className="terms-grid">
          {termsEntries.map((term, index) => {
            const Icon = iconMap[index % iconMap.length];
            return (
              <div className="terms-card" key={term.id || index}>
                <div className="terms-icon-wrap"><Icon size={24} /></div>
                <h3>{index + 1}. {isMr ? (term.titleMr || term.title) : term.title}</h3>
                <p>{isMr ? (term.descriptionMr || term.description) : term.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
